import React from 'react';
import classnames from 'classnames';
import { registerField } from 'core/forms';
import styles from '../styles/formFieldDivider.module.scss';
import { Typo } from 'uikit/content';

const FormFieldDivider = ({
  schema
}) => (
  <div className={classnames(styles.divider, schema.className)}>
    <Typo variant="h5" element="span">{schema.text}</Typo>
  </div>
);

FormFieldDivider.defaultProps = {};

FormFieldDivider.propTypes = {};

registerField('Divider', React.memo(FormFieldDivider));